import { useEffect, useRef } from "react";
import Lenis from "lenis";

let lenisInstance = null;

export const scrollToTarget = (target) => {
  if (lenisInstance) {
    lenisInstance.scrollTo(target, { offset: -80, duration: 1.4 });
  } else {
    const el = typeof target === "string" ? document.querySelector(target) : target;
    el?.scrollIntoView({ behavior: "smooth" });
  }
};

export const useLenis = () => {
  const rafRef = useRef(null);

  useEffect(() => {
    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduced) return undefined;

    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1.0 });
    lenisInstance = lenis;

    const raf = (time) => {
      lenis.raf(time);
      rafRef.current = requestAnimationFrame(raf);
    };
    rafRef.current = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"], button[data-scroll-to]');
      if (!anchor) return;
      const target = anchor.getAttribute("href") || anchor.getAttribute("data-scroll-to");
      if (target && target.startsWith("#") && document.querySelector(target)) {
        e.preventDefault();
        scrollToTarget(target);
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      document.removeEventListener("click", onClick);
      cancelAnimationFrame(rafRef.current);
      lenis.destroy();
      lenisInstance = null;
    };
  }, []);
};
